
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report_analytics/result/[companyID]/[departmentID]",
      function () {
        return require("private-next-pages/report_analytics/result/[companyID]/[departmentID]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report_analytics/result/[companyID]/[departmentID]"])
      });
    }
  